import React from 'react';
import {Link} from "react-router-dom";

const Open = props => {
    const {color, path} = props
    return (
        <Link className="link" to={path}>                
            <svg xmlns="http://www.w3.org/2000/svg" fill={color} height="20" viewBox="0 -960 960 960" width="20"><path d="M222.783-124.782q-41.005 0-69.503-28.498-28.498-28.498-28.498-69.503v-514.434q0-41.005 28.498-69.503 28.498-28.498 69.503-28.498H480v98.001H222.783v514.434h514.434V-480h98.001v257.217q0 41.005-28.498 69.503-28.498 28.498-69.503 28.498H222.783ZM404.523-336 336-404.523l332.694-332.694H576v-98.001h259.218V-576h-98.001v-92.694L404.523-336Z" /></svg>
        </Link>
    )
}
export default Open;